import { defineMessages } from "react-intl";

export const contextualLinks = defineMessages({
  devModePanel: {
    defaultMessage: "",
    id: "zRIsjN",
  },
  apiReference: {
    defaultMessage: "API reference",
    id: "Zvo5iu",
  },
  apiGuide: {
    defaultMessage: "API guide",
    id: "BA4leV",
  },
  webhooks: {
    defaultMessage: "",
    id: "zT1CvH",
  },
  extendingSaleor: {
    defaultMessage: "",
    id: "B8PvdI",
  },
  staffMembers: {
    defaultMessage: "",
    id: "19o9WS",
  },
  userPermissions: {
    defaultMessage: "User permissions",
    id: "5M+hLZ",
  },
  orders: {
    defaultMessage: "",
    id: "tl1/1E",
  },
  orderManagement: {
    defaultMessage: "order management",
    id: "91vQMc",
  },
  products: {
    defaultMessage: "",
    id: "C9cgck",
  },
  productConfigurations: {
    defaultMessage: "product configurations",
    id: "dVk241",
  },
  giftCards: {
    defaultMessage: "",
    description: "gift cards page subheader",
    id: "sOlOZB",
  },
  giftCardsDocs: {
    description: "",
    defaultMessage: "gift cards",
    id: "aBpkVh",
  },
  extensions: {
    defaultMessage: "",
    description: "extensions page subheader",
    id: "yeX6fA",
  },
  extensionsDocs: {
    defaultMessage: "extensions",
    description: "extensions page subheader",
    id: "hVwc73",
  },
});
